import React from 'react';
import { Route } from 'react-router-dom';
//import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

/* 
    PrivateRouter component to automatically redirect the user to the login page if they are not logged in. Otherwise,
    redirect them to the requested resource if they are authenticated. 
*/
export class PrivateRoute extends React.Component {
    render() {
        // if (!this.props.loggedIn) {
        //     return <Redirect to={{ pathname: '/overview', state: { from: this.props.location }}}/>;
        // }
        return <Route {...this.props} />;
    }
}

PrivateRoute.propTypes = {
    location: PropTypes.object,
};


// WEBPACK FOOTER //
// ./src/components/routers/PrivateRoute.js